import templateUrl from "./google-location.html";

export const googleLocationComponent = {
  bindings: {
    details: "<",
    placeholder: "@",
    disableAddress: "@",
    isRequired: "@",
    onAddressChange: "&",
    getLocationDetails: "&",
    isError: "<",
  },
  templateUrl,
  controller: class GoogleLocationComponent {
    constructor(
      $parse,
      $timeout,
      defaultErrorMessageResolver,
      GoogleLocationService
    ) {
      "ngInject";

      this.$parse = $parse;
      this.$timeout = $timeout;
      this.name = new Date().getTime() + Math.random();
      this.defaultErrorMessageResolver = defaultErrorMessageResolver;
      this.googleLocationService = GoogleLocationService;
    }
    $onInit() {
      this.placeholder = this.placeholder ? this.placeholder : "Search address";
      this._disableAddress = this.$parse(this.disableAddress || "false")(false);
      this._isRequired = !this.details
        ? this.$parse(this.isRequired || "false")(false)
        : false;
      this._isError = this.$parse(this.isError || "false")(false);
      this.place = {};
      this.addressDetails = {};
      var autoComplete;
      const searchId = "searchLocation" + this.name;
      var input = "";
      this.$timeout(() => {
        input = document.getElementById(searchId);
        autoComplete = new google.maps.places.Autocomplete(input, {
          types: ["geocode"],
          componentRestrictions: { country: "us" },
        });
        autoComplete.addListener("place_changed", getAddress.bind(this));
      });

      function getAddress() {
        this.place = autoComplete.getPlace();
        this.addressDetails = {};
        this.addressDetails.locationName = "";
        if (this.place.address_components) {
          this._isError = false;
          this.addressDetails = this.googleLocationService._formatAddress(
            this.place
          );
          this.addressDetails.status = this.details.status;
          this.addressDetails.addressId = this.details.addressId;
        } else {
          this._isError = true;
        }

        this.addressValidation(this.addressDetails);

        this.getLocationDetails({
          details: this.addressDetails,
        });
      }

      this.defaultErrorMessageResolver
        .getErrorMessages()
        .then((errorMessages) => {
          errorMessages["customErrorMessage"] =
            "Invalid Address, An address should have street name, state name and city name.";
        });
    }

    //Custom Address Validation
    addressValidation({ addressLine1 = "", cityName = "", stateName = "" }) {
      this._isRequired =
        !addressLine1 || !cityName || !stateName ? true : false;
      this._isError = this._isRequired;
      this.addressDetails.isError = this._isError;
    }

    clearLocation() {
      this._isRequired = true;
      this._isError = false;
      this.details = {};
      this.getLocationDetails({
        details: this.details,
      });
    }

    $onChanges(changes) {
      if (changes.disableAddress) {
        this._disableAddress = this.$parse(
          changes.disableAddress.currentValue || "false"
        )(false);
      }
      if (changes && changes.isRequired) {
        this._isRequired = this.$parse(
          changes.isRequired.currentValue || "true"
        )(true);
      }
      if (changes && changes.isError) {
        this._isError = changes.isError.currentValue;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/google-location/google-location.component.js